import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="new-card"
export default class extends Controller {
  static targets = ["orientation", "orientationDiv"]
  connect() {
  }

  updateFormFactor(event){
    if(event.target.value === "jumbo_postcard"){
      this.orientationTarget.value = 'landscape'
      this.orientationDivTarget.classList.add('d-none')
    }else{
      this.orientationDivTarget.classList.remove('d-none')
    }
  }
}
